module.exports = __webpack_public_path__ + "static/media/gorra (5).91076723.png";